import Zone from "@insite/client-framework/Components/Zone";
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
import CookiePrivacyPolicyPopup from "@insite/content-library/Components/CookiePrivacyPolicyPopup";
import Page, { PageProps as MobiusPageProps } from "@insite/mobius/Page";
import * as React from "react";

/* Husky Custom Code - Start */
import Hidden from "@insite/mobius/Hidden";
import { css } from "styled-components";
/* Husky Custom Code - End */

export interface FooterStyles {
    page?: MobiusPageProps;
}

const footerStyles: FooterStyles = {
    /* Husky Custom Code - Start */
    page: {
        tabIndex: -1,
        fullWidth: [true, true, true, true, true],
        css: css`
            padding: 0;
            background: rgba(242, 245, 247, 0.35);
            border-top: 1px solid rgba(0, 0, 0, 0.4);
            outline: none;
        `,
    },
    /* Husky Custom Code - End */
};

const styles = footerStyles;

const Footer = ({ id }: PageProps) => (
    <Page
        as="footer"
        isFooter={true}
        {...styles.page}
        // Husky Custom Code
        data-test-selector="footerContent"
    >
        {/* Husky Custom Code  - Start */}
        <Hidden below="lg">
            <Zone contentId={id} zoneName="Content" />
            {/* Husky Removed - CookiePrivacyPolicyPopup */}
        </Hidden>
        <Hidden above="md">
            <Zone contentId={id} zoneName="MobileContent" />
        </Hidden>
        {/* Husky Custom Code  - End */}
    </Page>
);

const pageModule: PageModule = {
    component: Footer,
    definition: {
        hasEditableTitle: false,
        hasEditableUrlSegment: false,
        pageType: "System",
    },
};

export default pageModule;

/**
 * @deprecated Use string literal "Footer" instead of this constant.
 */
export const FooterContext = "Footer";
